import React from 'react'
import { Loader } from './Loader'

export type PaginationLoaderProps = {
  listState: {
    error?: Error
    loading: boolean
    pageInfo: {
      hasNextPage: boolean
    }
  }
  fetchNextPage: (options: { startFresh: boolean }) => void
}

export const PaginationLoader = ({
  listState,
  fetchNextPage,
}: PaginationLoaderProps) => {
  const load = React.useCallback(
    ({ startFresh = false } = {}) => {
      if (
        !listState.error &&
        !listState.loading &&
        listState.pageInfo.hasNextPage
      ) {
        fetchNextPage({ startFresh })
      }
    },
    [
      listState.error,
      listState.loading,
      listState.pageInfo.hasNextPage,
      fetchNextPage,
    ]
  )

  if (!listState.pageInfo.hasNextPage) {
    return null
  }

  return <Loader load={load} />
}
